import { Trans } from '@lingui/react/macro';
import type { BusinessDataConnection } from '../../services/businessDataConnectionService';
import type { BusinessDataOperation } from '../../services/businessDataService';
import { KeyIcon, Spinner, WarningIcon } from './icons';

const PILL = 'flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider';

interface Props {
  conn: BusinessDataConnection;
  scanJob?: BusinessDataOperation;
  isScanning: boolean;
}

// Status pill for a connected service card. A connection-level auth failure wins;
// otherwise the pill reflects scan state, defaulting to the familiar "Active".
export function ConnectionStatusBadge({ conn, scanJob, isScanning }: Props) {
  if (conn.status === 'error') {
    return (
      <span className={`${PILL} bg-red-500/10 text-red-600 dark:text-red-400`}>
        <KeyIcon className="w-2.5 h-2.5" /><Trans>Auth failed</Trans>
      </span>
    );
  }
  if (isScanning) {
    return (
      <span className={`${PILL} bg-blue-500/10 text-blue-600 dark:text-blue-400`}>
        <Spinner className="w-2.5 h-2.5" /><Trans>Scanning</Trans>
      </span>
    );
  }
  if (scanJob?.status === 'error') {
    return (
      <span className={`${PILL} bg-red-500/10 text-red-600 dark:text-red-400`}>
        <WarningIcon className="w-2.5 h-2.5" strokeWidth={2.5} /><Trans>Scan failed</Trans>
      </span>
    );
  }
  return (
    <span className={`${PILL} bg-green-500/10 text-green-600 dark:text-green-400`}>
      <span className="w-1.5 h-1.5 rounded-full bg-green-500" /><Trans>Active</Trans>
    </span>
  );
}
